<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-textarea
          outlined
          name="input-7-4"
          label="Descrição da notificação"
          v-model="$v.formNotificacao.ds_notificacao.$model"
          :error-messages="
            validacaoForm($v.formNotificacao.ds_notificacao, 'Mensagem')
          "
        ></v-textarea>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" md="2" class="d-flex justify-start">
        <v-menu
          ref="dataNotificacao"
          v-model="menuDataNotif"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          min-width="auto"
          class="d-flex justify-start"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              id="dataNotificacao"
              v-mask="['##/##/####']"
              v-model="$v.formNotificacao.dataString.$model"
              :error-messages="validacaoForm($v.formNotificacao.dataString, 'Data Notificação')"
              label="Data Notificação"
              reactive
              @input="changeValueData($event)"
              autocomplete="nope"
            >
              <v-icon slot="append" @click="menuDataNotif = !menuDataNotif"> mdi-calendar </v-icon>
            </v-text-field>
          </template>
          <v-date-picker
            v-model="$v.formNotificacao.dataModel.$model"
            no-title
            scrollable
            @input="updateValueData($event)"
          >
          </v-date-picker>
        </v-menu>
      </v-col>

      <v-col cols="12" md="2" class="d-flex justify-start">

        <v-menu
          ref="menuTimeNotif"
          v-model="menuTimeNotif"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          max-width="290px"
          min-width="290px"
          class="d-flex justify-start"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              class="d-flex justify-start"
              id="horaNotificacao"
              v-mask="['##:##']"
              v-on:blur="menuTimeNotif = false"
              v-model="$v.formNotificacao.horanotiftela.$model"
              :error-messages="validacaoForm($v.formNotificacao.horanotiftela, 'Hora Notificação')"
              label="Hora Notificação"
              autocomplete="nope"
            >
              <v-icon slot="append" @click="menuTimeNotif = !menuTimeNotif"> mdi-clock </v-icon>
            </v-text-field>
          </template>
          <v-time-picker
            v-if="menuTimeNotif"
            v-model="formNotificacao.horanotiftela"
            format="24hr"
            full-width
            prepend-icon="mdi-clock-time-four-outline"
            no-title
            @click:minute="menuTimeNotif = false"
          ></v-time-picker>
        </v-menu>
      </v-col>
      <v-col cols="12" md="5" align="center">
        <v-select
          id="usuarioDestino"
          :items="usuarios"
          v-model="$v.formNotificacao.usuariodestino_id.$model"
          autocomplete="nope"
          item-text="text"
          item-value="value"
          label="Pra quem será a Notificação?"
        ></v-select>
      </v-col>
      <v-col cols="12" md="3" align="end">
        <v-btn color="success darken-1" @click="gravarNotificacao()" :loading="isLoad">
          Gravar
        </v-btn>
        <v-btn color="success darken-1" @click="actSelecionarNotificacao()">
          Cancelar
        </v-btn>
      </v-col>
    </v-row>

    <material-card
      color="success"
      title="Histórico de Notificações"
      text
      :isbutton="true"
    >
      <v-data-table
        :headers="headers"
        :items="notificacoes"
        :items-per-page="5"
        class="elevation-1"
        :sort-desc="[false, true]"
        multi-sort
      >
        <template v-slot:item.dt_notificacao="{ item }"
          >{{ item.dt_notificacao | datahora }}
        </template>

        <template v-slot:item.usuarioOrigem="{ item }">
          {{ item.usuario_origem ? item.usuario_origem : item.email_origem }}
        </template>

        <template v-slot:item.usuarioDestino="{ item }">
          {{ item.usuario_destino ? item.usuario_destino : item.email_destino }}
        </template>

        <template v-slot:item.dt_confirmacao="{ item }">
          {{ item.dt_confirmacao | datahora }}
        </template>

        <template v-slot:item.actions="{ item }">
          
          <v-icon
            small
            class="mr-2"
            v-if="item.dt_confirmacao != null">mdi-lock
            </v-icon>

          <v-icon
            small
            class="mr-2"
            v-if="item.dt_confirmacao == null"
            @click="editarNotificacao(item.notificacao_id)">mdi-pencil
          </v-icon>

          <v-icon small class="mr-2" v-if="item.dt_confirmacao != null">mdi-lock</v-icon>
          <v-icon small class="mr-2" v-if="item.dt_confirmacao == null" @click="deletarNotificacao(item)">mdi-delete</v-icon>

        </template>
      </v-data-table>
    </material-card>
  </v-container>
</template>

<script>
import {
  required,
  requiredIf,
  email,
  minLength,
  maxLength,
  numeric,
  helpers,
} from "vuelidate/lib/validators";
import validacaoForm from "@/mixins/validacaoForm";
import utils from "@/mixins/utils";
import notificacoesModel from "@/views/Notificacoes/_model";
import { mapGetters, mapActions, mapState, mapMutations, createLogger } from "vuex";

export default {
  mixins: [utils, validacaoForm],
  name: "Notificacoes",
  props: ["processo_id", "cliente_id"],

  data() {
    return {
      isLoad: false,
      usuarios: [],
      menuTimeNotif: false,
      menuDataNotif: false,
      timeinput: null,
      notificacoes: [],
      notificacao: {},
      formNotificacao: {},
      //formats: ["YYYY-MM-DD", "DD/MM/YYYY", "YYYY-MM-DD LT", "YYYY-MM-DD HH:mm:ss", "YYYY-MM-DD h:mm:ss A","YYYY-MM-DD HH:mm:ss","YYYY-MM-DD HH:mm"],
      //formatsBr: ["DD/MM/YYYY"],
      //formatsEn: ["YYYY-MM-DD h:mm:ss A", "YYYY-MM-DD HH:mm:ss", "YYYY-MM-DD HH:mm"],
      headers: [
        { text: "Dt.Notificação", value: "dt_notificacao" },
        { text: "Notificação", value: "ds_notificacao" },
        { text: "De ->", value: "usuarioOrigem" },
        { text: "Para", value: "usuarioDestino" },
        { text: "Dt.Leitura", value: "dt_confirmacao", align: "center" },
        { text: "Ações", value: "actions", sortable: false, align: "center" },
      ],
    };
  },

  validations: {
    formNotificacao: {
      ds_notificacao: {required, errors: []},
      dataString: {required, errors: []},
      horanotiftela: { erros: [] },
      usuariodestino_id: { errors: []},
      dataModel: {errors: []}
    },
  },
  created() {
    this.actSelecionarNotificacao();
    this.carregarDados();
    this.carregaUsuarios();
  },

  methods: {
    ...mapActions({
      actBuscarNotificacoes: "notificacao/GET_NOTIFICACOES",
      actBuscaUsuarios: "usuario/LOAD_DROPDOWN",
      actStoreNotificacao: "notificacao/STORE_NOTIFICACAO",
      actSelecionarNotificacao: "notificacao/NOTIFICACAO_SELECTED",
      actDeleteNotificacao: "notificacao/DELETE_NOTIFICACAO",
    }),

    ...mapGetters({
      getNotificacoesDoProcesso: "notificacao/GET_NOTIFICACOES",
      getUsuarios: "usuario/GET_DROPDOWN",
    }),

    changeValueData: function (value) {
      this.menuDataNotif = false
      if (value.length < 10 ) return
      this.formNotificacao.dataString = this.$moment(value, this.formatsBr).format('DD/MM/YYYY')
      this.formNotificacao.dataModel = this.$moment(value, this.formatsBr).format('YYYY-MM-DD')
    },

    updateValueData: function (value) {
      this.formNotificacao.dataString = this.$moment(value, this.formatsEn).format('DD/MM/YYYY')
      this.formNotificacao.dataModel = this.$moment(value, this.formatsEn).format('YYYY-MM-DD')
      this.menuDataNotif = false
    },

    carregaUsuarios() {
      this.actBuscaUsuarios()
        .then((resp) => {
          this.usuarios = this.getUsuarios();
        })
        .catch((e) => {
          console.log(e);
        });
    },

    carregarDados() {
      if (!this.processo_id > 0) return
      this.actBuscarNotificacoes(this.processo_id)
        .then(async (resp) => {
          this.notificacoes = await this.getNotificacoesDoProcesso();
        })
        .catch((e) => {
          console.log("carregarDados" + e);
        });
    },

    editarNotificacao(id) {
      try {
        this.actSelecionarNotificacao(id);
      } catch (error) {
        this.$toaster.error("Erro ao editar!", error);
      }
    },

    deletarNotificacao(notificacao) {
      this.$dialog
        .confirm(
          "Após excluído, a notificação não pode ser recuperada. Deseja continuar?",
          { loader: true, okText: "Sim", cancelText: "Não" }
        )
        .then(async (dialog) => {
          try {
            this.actDeleteNotificacao(notificacao);
            this.$toaster.success("Notificação excluida!");
          } catch (e) {
            this.$toaster.error(
              "Erro ao enviar dados para Api 'deletarNotificacao'"
            );
          } finally {
            dialog.close();
          }
        })
        .catch((e) => {});
    },

    async gravarNotificacao() {
      if (!(await this.validaForm())) return;
      this.store();
    },
    async validaForm() {
      this.$v.formNotificacao.$touch();
      if (!this.$v.formNotificacao.$invalid) {
        return true;
      } else if (this.$v.formNotificacao.$anyError) {
        return false;
      }
    },
    async store() {
      this.formNotificacao.dt_notificacao = `${this.formNotificacao.dataString} ${this.formNotificacao.horanotiftela}:00`

      var objStore = JSON.parse(JSON.stringify(this.formNotificacao))
      objStore.dt_notificacao = this.converteDataHoraParaApi(objStore.dt_notificacao)
      objStore.processo_id = this.processo_id;

      if (!this.validaDateWithNow(objStore.dt_notificacao)) {
        this.$toaster.error("Data da notificação não pode ser menor que a data atual")
        return false
      }
      
      this.isLoad = true
      try {
        await this.actStoreNotificacao(objStore)
        this.actSelecionarNotificacao()
        this.carregarDados()
        return true
      } catch (e) {
        this.$toaster.error("Erro não tratado em 'store'")
        console.log(e)
        return false
      }finally{
        this.isLoad = false
      }

    },
  },

  watch: {
    notificacaoSelecionada(newObjeto) {
      this.$v.formNotificacao.$reset();
      this.formNotificacao = Object.assign({}, newObjeto);
      this.formNotificacao.horanotiftela = this.formNotificacao.dt_notificacao ? this.$moment(this.formNotificacao.dt_notificacao, this.formatsEn).format("HH:mm") : null
      this.formNotificacao.dataString = this.formNotificacao.dt_notificacao ? this.$moment(this.formNotificacao.dt_notificacao, this.formatsEn).isValid() ? this.$moment(this.formNotificacao.dt_notificacao, this.formatsEn).format("DD/MM/YYYY") : null : null
      this.formNotificacao.dataModel = this.formNotificacao.dt_notificacao ? this.$moment(this.formNotificacao.dt_notificacao, this.formatsEn).isValid() ? this.$moment(this.formNotificacao.dt_notificacao, this.formatsEn).format("YYYY-MM-DD") : null : null
    },
    formNotificacao: {
      deep: true,
      immediate: true,
      handler() {
        //this.formNotificacao.dataModel = this.formNotificacao.dataString ? this.$moment(this.formNotificacao.dataString, "DD/MM/YYYY").format("YYYY-MM-DD") : null
        //this.formNotificacao.dataString = this.formNotificacao.dataModel ? this.$moment(this.formNotificacao.dataModel, "YYYY-MM-DD").format("DD/MM/YYYY") : null
      }
    }
  },

  computed: {
    ...mapState("notificacao", ["notificacaoSelecionada"])
  },
};
</script>




// WEBPACK FOOTER //
// src/views/Notificacoes/Notificacoes.vue